import { StyleSheet, Dimensions } from 'react-native'
import theme from '../../../theme'

const { width } = Dimensions.get('window')

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: 'white',
    },
    containerHeader: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingVertical: 6,
    },
    containerRow: {
        width: width,
        flexDirection: 'row',
        alignItems: 'center',
    },
    containerRowCard: {
        width: width - 24,
        flexDirection: 'row',
        alignItems: 'center',
        alignSelf: 'center',
        borderWidth: 0.5,
        borderRadius: 8,
        borderColor: theme.colors.lightGray,
        paddingTop: 20,
        paddingBottom: 12,
        marginHorizontal: 12,
        marginBottom: 12,
    },
    section: {
        fontSize: 15,
        fontWeight: '500',
        color: theme.colors.textPrimary,
        textAlign: 'center',
    },
    region: {
        fontSize: 15,
        fontWeight: 'bold',
        color: theme.colors.colorPrimary,
    },
    containerSection: {
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: theme.colors.filtersBackground,
        padding: 12,
    },
    card: {
        borderWidth: 0.5,
        borderRadius: 8,
        borderColor: theme.colors.lightGray,
        marginHorizontal: 12,
        marginTop: 16,
    },
    headerCard: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingHorizontal: 12,
        paddingTop: 16,
        paddingBottom: 12,
    },
    avatar: {
        width: 56,
        height: 56,
        borderRadius: 28,
    },
    titleSection: {
        fontSize: 15,
        fontWeight: 'bold',
        color: theme.colors.colorApproved,
        marginBottom: 2,
    },
    subtitleSection: {
        fontSize: 14,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        marginBottom: 2,
    },
    subtitleModule: {
        fontSize: 14,
        fontWeight: 'bold',
        color: theme.colors.textSecondary,
    },
    myExamsSection: {
        fontSize: 14,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        marginBottom: 2,
    },
    myPointsSection: {
        fontSize: 14,
        fontWeight: 'normal',
        color: theme.colors.textPrimary,
        marginBottom: 2,
    },
    descriptionSection: {
        fontSize: 13,
        fontWeight: 'bold',
        color: theme.colors.colorPrimary,
    },
    titleProgressBar: {
        fontSize: 14,
        fontWeight: 'bold',
        color: theme.colors.textSecondary,
    },
    reference: {
        width: 16,
        height: 8,
        borderRadius: 4,
        backgroundColor: theme.colors.colorPrimary,
        marginLeft: 8,
        marginRight: 4,
    },
    infoText: {
        fontSize: 12,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        margin: 12,
    },
    subtitle: {
        fontSize: 14,
        fontWeight: 'normal',
        color: theme.colors.textPrimary,
        marginLeft: 12,
    },
    containerProgress: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        marginHorizontal: 12,
    },
    progressBar: {
        flex: 1,
        borderRadius: 12,
        borderColor: 'transparent',
    },
    containerProgressCircle: {
        position: 'absolute',
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
    },
    percentage: {
        fontSize: 21,
        fontWeight: 'bold',
        color: theme.colors.textSecondary,
    },
    percentageBis: {
        fontSize: 18,
        fontWeight: 'bold',
        color: theme.colors.textSecondary,
    },
    containerDataSection: {
        flex: 1,
        borderRadius: 8,
        backgroundColor: 'white',
        padding: 12,
        alignItems: 'center',
        marginLeft: 12,
    },
    buttonContainer: {
        flexDirection: 'column',
        position: 'absolute',
        paddingVertical: 15,
        bottom: 15,
        width: '100%',
    },
    mainButton: {
        marginTop: 10,
        backgroundColor: theme.colors.colorPrimary,
        padding: 10,
        borderRadius: 10,
        marginHorizontal: 10,
    },
    mainButtonDisabled: {
        marginTop: 10,
        backgroundColor: theme.colors.lightGray,
        padding: 10,
        borderRadius: 10,
        marginHorizontal: 10,
    },
    mainButtonText: {
        fontSize: 16,
        color: 'white',
        fontWeight: 'bold',
        textAlign: 'center',
    },
    mainButtonTextDisabled: {
        fontSize: 16,
        color: theme.colors.textSecondary,
        fontWeight: 'bold',
        textAlign: 'center',
    },
    borderButton: {
        marginTop: 12,
        marginBottom: 24,
        marginHorizontal: 12,
        backgroundColor: 'white',
        borderWidth: 2,
        borderColor: theme.colors.colorPrimary,
        padding: 8,
        borderRadius: 10,
    },
    borderButtonText: {
        fontSize: 16,
        color: theme.colors.colorPrimary,
        fontWeight: 'bold',
        textAlign: 'center',
    },
    noDataProgress: {
        width: 230,
        height: 230,
        alignSelf: 'center',
    },
    noDataEvaluations: {
        width: 132,
        height: 132,
        alignSelf: 'center',
    },
    noDataText: {
        fontSize: 16,
        fontWeight: 'bold',
        color: theme.colors.textSecondary,
        textAlign: 'center',
        paddingHorizontal: 60,
    },
    margin: {
        margin: 12,
    },
    marginLeft: {
        marginLeft: 4,
    },
    marginRight: {
        marginRight: 12,
    },
    marginHorizontal: {
        marginHorizontal: 12,
    },
    paddingHorizontal: {
        paddingHorizontal: 12,
    },
    padding: {
        padding: 12,
    },
    paddingBottom: {
        paddingBottom: 12,
    },
    alignCenter: {
        alignSelf: 'center',
    },
    absoluteCenter: {
        position: 'absolute',
    },
    spacer1: {
        height: 8,
    },
    spacer2: {
        height: 16,
    },
    spacerText: {
        width: 8,
    },
})

export default styles
